import { IEvaluationCommand } from "@Evaluation/cqrs";

export class SaveResultsToNewAttributeCommandV1 implements IEvaluationCommand {
	$type: string = 'TCh.Domain.Evaluation.ValueAnalysis.Commands.SaveResultsToNewAttributeCommandV1, TCh.Domain.Evaluation';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	NewAttributeName: string;
	Values: string[];

	constructor(userId: number, workspaceId: number, projectId: number, evalModelId: number, newAttributeName: string, values: string[])
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = evalModelId.toString();
		this.NewAttributeName = newAttributeName;
		this.Values = values;
	}

	static matchType(cmd: IEvaluationCommand)	{
		return cmd.$type == 'TCh.Domain.Evaluation.ValueAnalysis.Commands.SaveResultsToNewAttributeCommandV1, TCh.Domain.Evaluation'
	}
}

export class SaveResultsToExistingAttributeCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.ValueAnalysis.Commands.SaveResultsToExistingAttributeCommandV1, TCh.Domain.Evaluation';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	AttributeId: number;
	Values: string[];

	constructor(userId: number, workspaceId: number, projectId: number, evalModelId: number, attributeId: number, values: string[])
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = evalModelId.toString();
		this.AttributeId = attributeId;
		this.Values = values;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.ValueAnalysis.Commands.SaveResultsToExistingAttributeCommandV1, TCh.Domain.Evaluation'
	}
}